import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aa001b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = {
  id: "D_Profiles_Print",
  class: "DialogSection"
}
const _hoisted_10 = { class: "F-Bold F1_25em D-Flex" }
const _hoisted_11 = { class: "NOPRINT" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_13 = { class: "P-Rel W-75 ItemsContainer" }
const _hoisted_14 = { class: "CategoryRow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CategoryRowPlaceSaver" }, null, -1))
const _hoisted_16 = { class: "P-Rel W-75 ItemsContainer" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_18 = ["onBlur"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_20 = ["onBlur"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_23 = { class: "DialogSection" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_25 = {
  id: "D_Profiles_Print",
  class: "DialogSection"
}
const _hoisted_26 = { class: "F-Bold F1_25em D-Flex" }
const _hoisted_27 = { class: "NOPRINT" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_29 = {
  class: "W-100 D-Flex Shadow1",
  style: {"justify-content":"flex-end","gap":"0.5em"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_31 = {
  class: "W-100 ItemRow",
  style: {"top":"-3em"}
}
const _hoisted_32 = {
  class: "ItemImages",
  style: {"align-items":"center","justify-content":"center"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_37 = { style: {"width":"6.33em"} }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_39 = { style: {"width":"3em"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_48 = { class: "ItemImages" }
const _hoisted_49 = {
  key: 0,
  class: "Placeholder"
}
const _hoisted_50 = { class: "Actions Shadow2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_52 = ["onBlur"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_54 = ["onBlur"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_60 = {
  key: 0,
  class: "D-Flex H-100 BG2 Rad2",
  style: {"position":"absolute","top":"0","left":"0","gap":"1em","align-items":"center","z-index":"100"}
}
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1))
const _hoisted_64 = ["ToolTip", "onMousedown", "onTouchstart"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_66 = { class: "DialogSection" }
const _hoisted_67 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_68 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesButton = _resolveComponent("CookiesButton")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_vueQr = _resolveComponent("vueQr")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CookiesImageInput, {
              onSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.SaveData())),
              Folder: 'Catalogs',
              Res: 'D_Catalog_Image',
              style: {"border-radius":"var(--rad1)","width":"80%","height":"12em"}
            })
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CookiesNormalInput, {
              onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.SaveData())),
              Placeholder: _ctx.Translate('Catalog Name'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Catalog_Name') && _ctx.MEMRead('D_Catalog_Name') !== ''),
              Res: 'D_Catalog_Name',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput"]),
            _createVNode(_component_CookiesDescriptionBox, {
              onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.SaveData())),
              Placeholder: _ctx.Translate('Description'),
              Res: 'D_Catalog_Description'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Translate('Categories')), 1)
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_ctx.CookiesData?.Configs)
                  ? (_openBlock(), _createBlock(_component_CookiesImageInput, {
                      key: 0,
                      Default: _ctx.CookiesData?.Configs?.All_Category_ImgURL,
                      onSelected: _cache[3] || (_cache[3] = ($event: any) => (_ctx.EditAllCatImage())),
                      Res: `D_Catalog_CategoryImage_All`,
                      class: "Rad2",
                      style: {"border-radius":"var(--rad2)","width":"3.5em","height":"3.5em"}
                    }, null, 8, ["Default"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, _toDisplayString(_ctx.Translate('All')), 1)
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CookiesData?.Categories, (category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category.ID,
                  class: "CategoryRow",
                  style: _normalizeStyle(`top: ${5 * index}em;`)
                }, [
                  _createVNode(_component_CookiesImageInput, {
                    Default: category.ImgURL,
                    onSelected: ($event: any) => (_ctx.EditImage(category, 'Categories', `D_Catalog_CategoryImage_${index}`)),
                    Res: `D_Catalog_CategoryImage_${index}`,
                    class: "Rad2",
                    style: {"border-radius":"var(--rad2)","width":"3.5em","height":"3.5em"}
                  }, null, 8, ["Default", "onSelected", "Res"]),
                  _hoisted_17,
                  _createElementVNode("span", {
                    onBlur: ($event: any) => (_ctx.EditCategory($event, category, 'Name')),
                    contenteditable: "true",
                    class: "EditableText"
                  }, _toDisplayString(category.Name), 41, _hoisted_18),
                  _hoisted_19,
                  _createElementVNode("span", {
                    onBlur: ($event: any) => (_ctx.EditCategory($event, category, 'Description')),
                    contenteditable: "true",
                    class: "EditableText"
                  }, _toDisplayString(category.Description), 41, _hoisted_20),
                  _hoisted_21,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CookiesIcon, {
                      class: "SQR1_5em Pointer",
                      onClick: ($event: any) => (_ctx.RemoveItem(category, 'Categories')),
                      ID: 'Delete'
                    }, null, 8, ["onClick"])
                  ])
                ], 4))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CookiesData?.Categories, (category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "CategoryRowPlaceSaver"
                }))
              }), 128))
            ])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", null, [
              _createVNode(_component_CookiesIcon, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.AddCategory())),
                Tooltip: _ctx.Translate('Add'),
                class: "M-Auto SQR2_5em Pointer",
                style: {"padding-inline-end":"0.5em"},
                ID: 'Add'
              }, null, 8, ["Tooltip"])
            ])
          ]),
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.Translate('Items')), 1)
            ]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_CookiesButton, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.DownloadAllQRs())),
                Settings: ({ Icon: 'ItemImport' } as CookiesButtonComponent)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Translate('Download QRs')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_CookiesButton, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.DownloadAllImages())),
                Settings: ({ Icon: 'ItemImport' } as CookiesButtonComponent)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Translate('Download Images')), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_30,
            _createElementVNode("div", {
              id: "CatalogItemsContainer",
              onTouchmove: _cache[7] || (_cache[7] = ($event: any) => (_ctx.IsTouching($event))),
              onMousemove: _cache[8] || (_cache[8] = ($event: any) => (_ctx.IsMoving($event))),
              style: _normalizeStyle([_ctx.GrappedItem ? 'user-select: none;' : '', {"margin-top":"3em"}]),
              class: "P-Rel W-100 ItemsContainer"
            }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.Translate('Images')), 1),
                _hoisted_33,
                _hoisted_34,
                _createElementVNode("div", null, _toDisplayString(_ctx.Translate('Code')), 1),
                _hoisted_35,
                _createElementVNode("div", null, _toDisplayString(_ctx.Translate('Name')), 1),
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.Translate('Category')), 1),
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.Translate('QR')), 1),
                _hoisted_40,
                _hoisted_41,
                _hoisted_42,
                _hoisted_43,
                _hoisted_44,
                _hoisted_45,
                _hoisted_46,
                _hoisted_47
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MEMRead('D_Catalog_Items'), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.ID,
                  class: _normalizeClass([_ctx.GrappedItem?.ID === item?.ID ? 'ItemPlacer' : '', "ItemRow"]),
                  style: _normalizeStyle(`top: ${5 * index}em;`)
                }, [
                  _createElementVNode("span", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("div", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Media, (media) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: media.ID,
                        class: "H-100 D-Flex P-Rel"
                      }, [
                        (media.URL === item.ImgURL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createVNode(_component_CookiesIcon, { ID: 'GrayCheck' })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_CookiesIcon, {
                            onClick: ($event: any) => (_ctx.MakeDefaultMedia(item, media)),
                            ToolTip: _ctx.CashedTrans.Default,
                            ID: 'GrayCheck'
                          }, null, 8, ["onClick", "ToolTip"]),
                          _createVNode(_component_CookiesIcon, {
                            onClick: ($event: any) => (_ctx.ViewImage(media.URL)),
                            ToolTip: _ctx.CashedTrans.Show,
                            ID: 'Search'
                          }, null, 8, ["onClick", "ToolTip"]),
                          _createVNode(_component_CookiesIcon, {
                            onClick: ($event: any) => (_ctx.RemoveMedia(item, media)),
                            ToolTip: _ctx.CashedTrans.Delete,
                            ID: 'Delete'
                          }, null, 8, ["onClick", "ToolTip"])
                        ]),
                        _createVNode(_component_CookiesImageInput, {
                          CropWindow: true,
                          Default: media.URL,
                          onSelected: ($event: any) => (_ctx.PostMedia(item, `D_Catalog_ItemImage_${item.ID}_${media.ID}`, media)),
                          Res: `D_Catalog_ItemImage_${item.ID}_${media.ID}`,
                          class: "Rad2"
                        }, null, 8, ["Default", "onSelected", "Res"])
                      ]))
                    }), 128)),
                    (item?.Media?.length < 4)
                      ? (_openBlock(), _createBlock(_component_CookiesImageInput, {
                          key: 0,
                          ToolTip: _ctx.CashedTrans.NewImage,
                          CropWindow: true,
                          Default: '',
                          onSelected: ($event: any) => (item.Media?.length > 0 ? _ctx.PostMedia(item, `D_Catalog_ItemImage_${item.ID}_New`, null) : _ctx.EditImage(item, 'Items', `D_Catalog_ItemImage_${item.ID}_New`)),
                          Res: `D_Catalog_ItemImage_${item.ID}_New`,
                          class: "Rad2"
                        }, null, 8, ["ToolTip", "onSelected", "Res"]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_51,
                  _createElementVNode("span", {
                    onBlur: ($event: any) => (_ctx.EditItem($event, item, 'Code')),
                    contenteditable: "true",
                    class: "EditableText"
                  }, _toDisplayString(item.Code), 41, _hoisted_52),
                  _hoisted_53,
                  _createElementVNode("span", {
                    onBlur: ($event: any) => (_ctx.EditItem($event, item, 'Name')),
                    contenteditable: "true",
                    class: "EditableText"
                  }, _toDisplayString(item.Name), 41, _hoisted_54),
                  _hoisted_55,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CookiesDropInputObject, {
                      RowHeight: '3em',
                      Default: _ctx.CategoriesMap['Cat_' + item.CategorySeq]?.Name,
                      onSelected: ($event: any) => (_ctx.EditItemCategory(item, `D_CatalogEdit_${item.ID}`)),
                      Width: '8em',
                      Height: '1.5em',
                      class: "F_75em",
                      Res: `D_CatalogEdit_${item.ID}`,
                      Options: _ctx.CookiesData?.Categories,
                      Selectors: ['Name']
                    }, null, 8, ["Default", "onSelected", "Res", "Options"])
                  ]),
                  _hoisted_56,
                  (_ctx.$store.state.CookiesConfig.Catalog_MainURL)
                    ? (_openBlock(), _createBlock(_component_vueQr, {
                        key: 0,
                        callback: _ctx.SaveQRDataURI,
                        qid: item.ID,
                        style: {"width":"3em","height":"3em"},
                        text: `${_ctx.$store.state.CookiesConfig.Catalog_MainURL}/I/Q/${_ctx.CookiesData?.Sequence}/${item?.Sequence}`,
                        class: "Rad1 M-Auto",
                        size: 800,
                        colorLight: 'rgba(0,0,0,0)',
                        backgroundColor: 'rgba(0,0,0,0)'
                      }, null, 8, ["callback", "qid", "text", "colorLight", "backgroundColor"]))
                    : _createCommentVNode("", true),
                  _hoisted_57,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CookiesIcon, {
                      ToolTip: ((item?.Tags?.IsHidden ? _ctx.CashedTrans.Hidden : _ctx.CashedTrans.NotHidden) as string),
                      style: _normalizeStyle(item?.Tags?.IsHidden ? '' : 'opacity: 0.5'),
                      Color: (item?.Tags?.IsHidden ? ('var(--colorr1)') as IconColor : undefined),
                      class: "SQR1_5em Pointer",
                      onClick: ($event: any) => (_ctx.ChangeHiddenState(item)),
                      ID: 'Show'
                    }, null, 8, ["ToolTip", "style", "Color", "onClick"])
                  ]),
                  _hoisted_58,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CookiesIcon, {
                      ToolTip: _ctx.CashedTrans.Delete,
                      class: "SQR1_5em Pointer",
                      onClick: ($event: any) => (_ctx.RemoveItem(item, 'Items')),
                      ID: 'Delete'
                    }, null, 8, ["ToolTip", "onClick"])
                  ]),
                  _hoisted_59,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CookiesIcon, {
                      onClick: ($event: any) => (_ctx.MEMWrite(`Catalog_EditDialog_${index}_Visibile`, true)),
                      ToolTip: _ctx.CashedTrans.Transfer,
                      class: "SQR1_5em Pointer",
                      ID: 'Leveling'
                    }, null, 8, ["onClick", "ToolTip"]),
                    (_ctx.MEMRead(`Catalog_EditDialog_${index}_Visibile`))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createVNode(_component_CookiesNumberInput, {
                            Step: 1,
                            Min: 1,
                            Max: _ctx.MEMRead('D_Catalog_Items')?.length,
                            Res: `Catalog_EditDialog_${index}`
                          }, null, 8, ["Max", "Res"]),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.ChangeOrder(item, _ctx.MEMRead(`Catalog_EditDialog_${index}`) - 1), _ctx.MEMClean(`Catalog_EditDialog_${index}`))
                          }, _toDisplayString(_ctx.Translate('Transfer')), 9, _hoisted_61),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.MEMWrite(`Catalog_EditDialog_${index}_Visibile`, undefined)),
                            class: "BGRed2",
                            style: {"background-color":"var(--Colorr1)"}
                          }, _toDisplayString(_ctx.Translate('Back')), 9, _hoisted_62)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_63,
                  _createElementVNode("span", {
                    ToolTip: _ctx.CashedTrans.Sort,
                    onMousedown: ($event: any) => (_ctx.Grapped($event, item, index, 'Mouse')),
                    onTouchstart: ($event: any) => (_ctx.Grapped($event, item, index, 'Touch')),
                    class: "F-Bold F2em Color3 O-50 ObjectHolder"
                  }, "=", 40, _hoisted_64)
                ], 6))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MEMRead('D_Catalog_Items'), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "ItemRowPlaceSaver"
                }))
              }), 128))
            ], 36)
          ]),
          _hoisted_65,
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", null, [
              _createVNode(_component_CookiesIcon, {
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.AddItem())),
                Tooltip: _ctx.Translate('Add Item'),
                class: "M-Auto SQR2_5em Pointer",
                style: {"padding-inline-end":"0.5em"},
                ID: 'Add'
              }, null, 8, ["Tooltip"])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData?.Editing ? 'Catalogue_Edit': 'Catalogue_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("button", {
              class: _normalizeClass([_ctx.Saving ? 'Disabled' : '', "F-Bold CookiesButton DialogFooterButton"]),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.go(-1)))
            }, _toDisplayString(_ctx.Translate('Back')), 3)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}